import { Molecule, wrap, Wrapper } from 'AppReact'
import styled from 'styled-components'
import Text from 'atoms/text';
import Input from 'atoms/textArea';

const template = styled.div`
`

const wrapper = Wrapper(styled.div`margin-top: 5px;`)

export default Molecule({
  template,
  type: '',
  atoms: [
    {
      component: Text,
      name: 'Label',
      displayValue: ({ label }) => label
    },
    {
      component: wrap(Input, wrapper),
      name: 'Input',
      bindings: ({ value, rows, placeholder }) => ({ value, placeholder, rows })
    }
  ]
})